import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { Link, useLocation, useRouteMatch, useHistory } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './Successmodal.css'

function SuccessModal({ state,setState,successMessage}) {

    let dispatch=useDispatch()
    let history = useHistory();
    let { path, url } = useRouteMatch();
    const location = useLocation();  
    console.log("SuccessModal",location)
    
    let handleOkClick =()=>{

        setState(false)

        // if(isPreload)
        // {
        //     setEditMode(false)
        // }
        // else{

        //      if(successMessage.includes("successfully")){

        //             clearData()
    
        //         }
          

           

           
        // }

       
    }
    const [show, setShow] = useState(false);
    //setShow(state);
    const handleClose = () =>{
         setShow(false);
         setState(false)
         if(location?.pathname?.includes("settings"))
         {
          
           
         }
         if(location?.pathname?.includes("profile"))
         {
          //window.location.reload(false);
           
         }
         else
         {
          history.push({
            pathname:"/rpm",
           state: { message: "Successfully Escalated"},
          });
         }
         
    }
    const handleShow = () => setShow(true);
    console.log(successMessage,state);

    return (

        <>
          
        <Modal show={state} onHide={handleClose}
        backdrop="static"
        keyboard={false} centered>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>{successMessage}</Modal.Body>
          <Modal.Footer>
            
            <Button variant="secondary" onClick={handleClose}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
}

export default SuccessModal
